import { Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { PrimaryButton } from "../../../base/Components/PrimaryButton";
// import { useStyles } from "../muiStyling";
import { patientProfileCalls } from "../../../../store/patients/profile";
import { connect } from "react-redux";
import { IPatient } from "../../../../store/types/patient";
import { ProfilePopup } from "../../../popup/ProfilePopup";
import { PatientProfile } from "../../PatientProfile";
import {
  NumberUpdateDTO,
  PatientUpdateDTO,
  VerifyUpdatedNumberDTO,
} from "../../../../store/types/type";
import { UpdateNumberPopup } from "../../../popup/UpdateNumberPopup";
import { OtpPopup } from "../../../popup/OtpPopup";
import { Link } from "react-router-dom";


interface StateProps {
  // patientProfile: IPatient;
}
interface DispatchProps {
  updatePatientProfile: (updatePatientData: PatientUpdateDTO) => Promise<any>;
  updateProfileNumber: (numberUpdateDTO: NumberUpdateDTO) => Promise<any>;
  verifyUpdatedNumber: (verifyUpdatedNumberDTO: VerifyUpdatedNumberDTO) => Promise<any>;
}
interface OwnProps {
  read?: boolean;
  patientProfile: IPatient | undefined;
  getPatientProfile: () => Promise<any>;
}
type Props = OwnProps & StateProps & DispatchProps;

export const _ProfileCard = (props: Props) => {
  // const classes = useStyles();
  const [openPopupProfile, setOpenPopupProfile] = useState(false);
  const [openPopupNumber, setOpenPopupNumber] = useState(false);
  const [openPopupOtp, setOpenPopupOtp] = useState(false);
  React.useEffect(() => {
    const profileCall = async () => await props.getPatientProfile();
    if (profileCall) profileCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Grid spacing={2} container>
        {/* todo :dynamic profile by using map */}
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              marginTop: "3em",
              fontSize: "1rem",
              lineHeight: "0.6",
            }}
          >
            First Name : {props.patientProfile?.firstName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              marginTop: "3em",
              fontSize: "1rem",
              lineHeight: "0.6",
            }}
          >
            Last Name : {props.patientProfile?.lastName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "1rem",
              lineHeight: "0.6",
            }}
          >
            Email : {props.patientProfile?.email}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "1rem",
              lineHeight: "1.2",
            }}
          >
            Phone number for login OTP : {props.patientProfile?.phoneNumber}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          {props.read ? (
            ""
          ) : (
            <PrimaryButton
              onClick={() => setOpenPopupProfile(!openPopupProfile)}
              title="Edit Profile"
            />
          )}
        </Grid>



        <Grid item xs={12} sm={6}>
          {props.read ? (
            ""
          ) : (
            <PrimaryButton
              onClick={() => setOpenPopupNumber(!openPopupNumber)}
              title="Edit Number"
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.read ? (
            ""
          ) : (
            <Link
              to={{
                pathname: "https://square.link/u/Qa1PpILo",
                target: "_blank",
              }}
              onClick={() => {
                window.open("https://square.link/u/Qa1PpILo", "_blank");
              }}
            >
              Using Delores a lot this month? Enroll in the monthly discount program - $48 for 1 Month of $1 per 30 minutes (with select partcipating professionals)
            </Link>
          )}
        </Grid>
      </Grid>

      <ProfilePopup openPopupProfile={openPopupProfile} setOpenPopupProfile={setOpenPopupProfile}>
        <PatientProfile
          updatePatientProfile={props.updatePatientProfile}
          getPatientProfile={props.getPatientProfile}
          setOpenPopupProfile={setOpenPopupProfile}
        />
      </ProfilePopup>
      <UpdateNumberPopup
        openPopupNumber={openPopupNumber}
        setOpenPopupNumber={setOpenPopupNumber}
        updateProfileNumber={props.updateProfileNumber}
        getPatientProfile={props.getPatientProfile}
        setOpenPopupOtp={() => setOpenPopupOtp(!openPopupOtp)}
      />
      <OtpPopup
        openPopupOtp={openPopupOtp}
        setOpenPopupOtp={setOpenPopupOtp}
        verifyUpdatedNumber={props.verifyUpdatedNumber}
        getPatientProfile={props.getPatientProfile}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  // patientProfile: patientProfileSelectors.isPatientProfile(state.patients.patientProfile),
});

const mapDispatchToProps = (dispatch: any) => ({
  // getPatientProfile: () => dispatch(patientProfileCalls.getPatientProfile()),
  updatePatientProfile: (patientUpdateDTO: PatientUpdateDTO) =>
    dispatch(patientProfileCalls.updatePatientProfile(patientUpdateDTO)),
  updateProfileNumber: (numberUpdateDTO: NumberUpdateDTO) =>
    dispatch(patientProfileCalls.updatePatientNumber(numberUpdateDTO)),
  verifyUpdatedNumber: (verifyUpdatedNumber: VerifyUpdatedNumberDTO) =>
    dispatch(patientProfileCalls.verifyUpdatedNumber(verifyUpdatedNumber)),
});

export const ProfileCard = connect(mapStateToProps, mapDispatchToProps)(_ProfileCard);
